// **** Generated File: Do NOT edit!  **********
// Generated from java class: com.abinitio.webcommons.abweb.dto.inputargs.NumberFilterValue
// using template webcommons/abinitio/build/codegen/src/main/resources/tsTemplates/TSClass.vm

import { NumberFilterOperation } from "abweb/dto/generated/inputargs/NumberFilterOperation";
import { FilterValue } from "abweb/dto/inputargs/FilterValue";
export class NumberFilterValueBase extends FilterValue {
  /** Do NOT invoke directly, instead use strongly typed createNumberFilterValueBase factory method */
  constructor() {
    super();
  }

  // @ts-ignore: noUnusedLocals
  getJavaClass() {
    return "cawadi.NumberFilterValue";
  }
  initFromJson(json, deserializeContext) {
    this.initNumberFilterValue(json.componentGuid != null ? json.componentGuid : null, json.firstValue != null ? json.firstValue : null, json.isOpNegated != null ? json.isOpNegated : null, json.op != null ? NumberFilterOperation.fromJson(json.op) : null, json.secondValue != null ? json.secondValue : null);
  }
  initNumberFilterValue(componentGuid, firstValue, isOpNegated, op, secondValue) {
    this.initFilterValue(componentGuid);
    this._firstValue = firstValue;
    this._isOpNegated = isOpNegated;
    this._op = op;
    this._secondValue = secondValue;
  }
  toTSOG(result, serializeContext) {
    const retVal = super.toTSOG(result, serializeContext);
    if (this._firstValue != null) {
      retVal["firstValue"] = this._firstValue;
    }
    retVal["isOpNegated"] = this._isOpNegated;
    retVal["op"] = this._op;
    if (this._secondValue != null) {
      retVal["secondValue"] = this._secondValue;
    }
    return retVal;
  }
  get firstValue() {
    return this._firstValue;
  }
  set firstValue(value) {
    this._firstValue = value;
  }
  get isOpNegated() {
    return this._isOpNegated;
  }
  set isOpNegated(value) {
    this._isOpNegated = value;
  }
  get op() {
    return this._op;
  }
  set op(value) {
    this._op = value;
  }
  get secondValue() {
    return this._secondValue;
  }
  set secondValue(value) {
    this._secondValue = value;
  }
}
//# sourceMappingURL=NumberFilterValueBase.js.map
